import React, {useEffect, useState} from "react";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import {Container, Row, Col, Form} from "react-bootstrap";
import {UserDashboardPageContent, UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import {ButtonComponent, FormDropdownComponent} from "@Components/Forms";

import GmailLogo from "./@Icons/gmail_logo.svg";
import OutlookLogo from "./@Icons/logo-outlook.svg";
import SlackLogo from "./@Icons/logo-slack.svg";
import ButtonPlus from "./@Icons/button-plus-icon.svg";
import ButtonComputer from "./@Icons/button-computer.svg";
import ButtonMobilePhone from "./@Icons/button-mobile-phone.svg";
import ButtonDesktop from "./@Icons/button-desktop.svg";
import IconSecurityS from "./@Icons/icon-security-s-green.svg";
import IconMobilePhoneS from "./@Icons/icon-mobile-phone-s-grey.svg";
import IconMessageS from "./@Icons/icon-message-s-grey.svg";
import IconMailS from "./@Icons/icon-mail-s-grey.svg";
import IconSettingsS from "./@Icons/icon-settings-s-grey.svg";
import IconConnectS from "./@Icons/icon-connect-s-grey.svg";
import {SvgIconComponent} from "@Components/Elements";
import IconDisconnectS from "@Pages/@@UserPages/@Dashboard/@Settings/@Icons/icon-disconnect-s-grey.svg";
import BadgeElementComponent from "@Components/@Elements/@Badges";
import UserDashboardUserMenuComponent from "@Pages/@@UserPages/@@Dashboard/@@@Menu";


export const UserDashboardPrivacyAndSecurityPage:React.FC = () => {

    const [systemCommunicateMessage, setSystemCommunicateMessage] = useState('');

    const [profileVisibilityEmailAddressSetting, setProfileVisibilityEmailAddressSetting] = useState(0);
    const [profileVisibilityPhoneNumberSetting, setProfileVisibilityPhoneNumberSetting] = useState(0);
    const [profileVisibilityProfilePictureSetting, setProfileVisibilityProfilePictureSetting] = useState(0);

    const changeProfileVisibilityEmailAddressSetting = (optionID: number) => {
        setProfileVisibilityEmailAddressSetting(optionID);
        changeSecuritySettingHandler();
    };

    const changeProfileVisibilityPhoneNumberSetting = (optionID: number) => {
        setProfileVisibilityPhoneNumberSetting(optionID);
        changeSecuritySettingHandler();
    };

    const changeProfileVisibilityProfilePictureSetting = (optionID: number) => {
        setProfileVisibilityProfilePictureSetting(optionID);
        changeSecuritySettingHandler();
    };

    useEffect(() => {
        setProfileVisibilityEmailAddressSetting(2);
        setProfileVisibilityPhoneNumberSetting(2);
        setProfileVisibilityProfilePictureSetting(1);
    }, []);

    useEffect(() => {
        return () => {
            setProfileVisibilityEmailAddressSetting(1);
            setProfileVisibilityPhoneNumberSetting(1);
            setProfileVisibilityProfilePictureSetting(2);
        };
    }, []);

    const changeSecuritySettingHandler = () => {
        setSystemCommunicateMessage('Changes Saved');
    };

    return (
        <Container className={'user-dashboard-page-container'}>
            <Row className={'user-dashboard-page-container__content'}>

                {/*<UserDashboardPageUserMenu />*/}

                <UserDashboardUserMenuComponent />

                <UserDashboardPageContent
                    headingText={'Privacy & Security Settings'}
                    descriptionText={'Manage your privacy preferences, security settings, and connected applications'}
                >

                    <UserDashboardPageContentSection
                        sectionName={'user-security-profile-options'}
                        sectionHeaderText={'Profile Visibility'}
                        sectionDescriptionText={'Control what information is visible to others'}
                    >

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Email Address</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Show your email to other users</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={4} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'Public' }, { optionID: 2, optionValue: 'Private' }]}
                                        optionChoiceHandler={(optionID) => changeProfileVisibilityEmailAddressSetting(optionID)}
                                        selectedOptionID={profileVisibilityEmailAddressSetting}
                                        // fieldDisabledStatus={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Phone Number</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Display your phone number</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={4} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'Public' }, { optionID: 2, optionValue: 'Private' }]}
                                        optionChoiceHandler={(optionID) => changeProfileVisibilityPhoneNumberSetting(optionID)}
                                        selectedOptionID={profileVisibilityPhoneNumberSetting}
                                        // fieldDisabledStatus={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Profile Picture</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Who can see your profile picture</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={4} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'Public' }, { optionID: 2, optionValue: 'Private' }]}
                                        optionChoiceHandler={(optionID) => changeProfileVisibilityProfilePictureSetting(optionID)}
                                        selectedOptionID={profileVisibilityProfilePictureSetting}
                                        // fieldDisabledStatus={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-security-authentication'}
                        sectionHeaderText={'Two-Factor Authentication'}
                        sectionDescriptionText={'Add an extra layer of security to your account'}
                    >

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={1} lg={'auto'} className={'user-dashboard-switch-option-element__option-icon'}>
                                    <SvgIconComponent iconSource={IconSecurityS} />
                                </Col>
                                <Col xs={9} lg={11} className={'user-dashboard-switch-option-element__option-content has-option-icon'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>2FA is currently enabled</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Your account is protected with authenticator app</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={3} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>

                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={1} lg={'auto'} className={'user-dashboard-switch-option-element__option-icon'}>
                                    <SvgIconComponent iconSource={IconMobilePhoneS} />
                                </Col>
                                <Col xs={8} lg={11} className={'user-dashboard-switch-option-element__option-content has-option-icon'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Authenticator App</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Google Authenticator, Authy, etc.</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={3} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={() => changeSecuritySettingHandler()} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={1} lg={'auto'} className={'user-dashboard-switch-option-element__option-icon'}>
                                    <SvgIconComponent iconSource={IconMessageS} />
                                </Col>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content has-option-icon has-button-option'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>SMS Verification</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Receive codes via text message</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={3} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <ButtonComponent
                                        text={'Setup'}
                                        type={'flat'} iconLeft={IconSettingsS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={1} lg={'auto'} className={'user-dashboard-switch-option-element__option-icon'}>
                                    <SvgIconComponent iconSource={IconMailS} />
                                </Col>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content has-option-icon has-button-option'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Email Verification</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Backup method via email</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={3} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <ButtonComponent
                                        text={'Setup'}
                                        type={'flat'} iconLeft={IconSettingsS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    {/*<UserDashboardPageContentSection*/}
                    {/*    sectionName={'user-security-'}*/}
                    {/*    sectionHeaderText={''}*/}
                    {/*    sectionDescriptionText={''}*/}
                    {/*>*/}

                    {/*    <Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                    {/*        <Row className={'user-dashboard-connected-app-element__content'}>*/}
                    {/*            <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                    {/*                <SvgIconComponent iconSource={ButtonComputer} />*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                    {/*                <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                    {/*                        <span>MacBook Pro - Chrome</span>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                    {/*                        <span>San Francisco, CA • Active now</span>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-additional-info'}>*/}
                    {/*                        <BadgeElementComponent*/}
                    {/*                            badgeType={'success'} badgeSize={'md'}*/}
                    {/*                            badgeText={'Current Session'} badgeIcon={false}*/}
                    {/*                        />*/}
                    {/*                    </Col>*/}
                    {/*                </Row>*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                    {/*                <span className={'link-element-button'}>This device</span>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*    </Col>*/}

                    {/*    <Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                    {/*        <Row className={'user-dashboard-connected-app-element__content'}>*/}
                    {/*            <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                    {/*                <SvgIconComponent iconSource={ButtonMobilePhone} />*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                    {/*                <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                    {/*                        <span>iPhone 14 - Safari</span>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                    {/*                        <span>San Francisco, CA • 2 hours ago</span>*/}
                    {/*                    </Col>*/}
                    {/*                </Row>*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                    {/*                <span className={'link-element-button'}>Sign Out</span>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*    </Col>*/}

                    {/*    <Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                    {/*        <Row className={'user-dashboard-connected-app-element__content'}>*/}
                    {/*            <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                    {/*                <SvgIconComponent iconSource={ButtonDesktop} />*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                    {/*                <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                    {/*                        <span>Windows PC - Edge</span>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                    {/*                        <span>New York, NY • 3 days ago</span>*/}
                    {/*                    </Col>*/}
                    {/*                </Row>*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                    {/*                <span className={'link-element-button'}>Sign Out</span>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*    </Col>*/}

                    {/*</UserDashboardPageContentSection>*/}

                    <UserDashboardPageContentSection
                        sectionName={'user-security-connected-apps'}
                        sectionHeaderText={'Connected Applications'}
                        sectionDescriptionText={'Manage third-party apps with access to your account'}
                    >

                        {/*<Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                        {/*    <Row className={'user-dashboard-connected-app-element__content'}>*/}
                        {/*        <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                        {/*            <SvgIconComponent iconSource={GmailLogo} />*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                        {/*            <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                        {/*                    <span>Google Account</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                        {/*                    <span>Email access for claim detection • Connected 6 months ago</span>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                        {/*            <span className={'link-element-button'}>Revoke Access</span>*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                        {/*<Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                        {/*    <Row className={'user-dashboard-connected-app-element__content'}>*/}
                        {/*        <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                        {/*            <SvgIconComponent iconSource={OutlookLogo} />*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                        {/*            <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                        {/*                    <span>Microsoft Outlook</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                        {/*                    <span>Email access for claim detection • Connected 3 months ago</span>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                        {/*            <span className={'link-element-button'}>Revoke Access</span>*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                        {/*<Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                        {/*    <Row className={'user-dashboard-connected-app-element__content'}>*/}
                        {/*        <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                        {/*            <SvgIconComponent iconSource={SlackLogo} />*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                        {/*            <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                        {/*                    <span>Slack Integration</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                        {/*                    <span>Notifications and updates • Connected 1 month ago</span>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                        {/*            <span className={'link-element-button'}>Revoke Access</span>*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                        <Col xs={12} className={'user-dashboard-connected-app-element'}>
                            <Row className={'user-dashboard-connected-app-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>
                                    <SvgIconComponent iconSource={ButtonPlus} />
                                </Col>
                                <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>
                                    <Row className={'user-dashboard-connected-app-element__app-information__content'}>
                                        <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>
                                            <span>Connect New App</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>
                                            <span>Add another email provider</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>
                                    <ButtonComponent
                                        text={'Connect'}
                                        type={'flat'} iconLeft={IconConnectS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                </UserDashboardPageContent>

            </Row>
        </Container>
    );

};


export default UserDashboardPrivacyAndSecurityPage;
